import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import { useSearchParams } from "react-router-dom";

import ProjectService from "../services/ProjectService";
import ProjectLocationService from "../services/ProjectLocationService";
import StorageService from "../services/StorageService";
import ProjectStoreService from "../services/ProjectStoreService";
import ItemsService from "../services/ItemsServices";
import stockReturnService from "../services/stockReturnService";
import StockInDetailsService from "../services/StockInDetailsService";
import StockIndentService from "../services/stockIndentService";
import TransporterService from "../services/TransporterService";
import MessageDialog from "../components/MessageDialog";
import Select from "react-select";
import Loading from "../components/loading";


export default function AddStockReturn() {
  const [companyName, setCompanyName] = useState("Default Company");
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingEdit, setLoadingEdit] = useState(false);

  const [returnItems, setReturnItems] = useState([
    { itemId: "", itemDescription: "", UOM: "", quantity: "", issuedQty: 0, avalibleQty: 0, stockOutVoucherNo: "", voucherItems: [], toStoreId: "", damagedQty: "", availableUsable: 0, availableDamaged: 0, tempUsable: "0.000", tempDamaged: "0.000", loadingItems: false, loadingQty: false },
  ]);

  const checkIsScrapStore = (toStoreId) => {
    if (!toStoreId) return false;
    const store = stores.find((s) => String(s.storeId) === String(toStoreId));
    return store ? String(store.storeCode || "").toUpperCase().startsWith("SCRAP") : false;
  };




  const [projects, setProjects] = useState([]);
  const [stores, setStores] = useState([]);
  const [projectLocations, setProjectLocations] = useState([]);
  const [transporters, setTransporters] = useState([]);
  const [items, setItems] = useState([]);

  const [projectId, setProjectId] = useState("");

  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  // const messageTimer = useRef(null);
  const inputRefs = useRef([]);

  const [vouchers, setVouchers] = useState([]);
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const editId = searchParams.get("id");

  const today = new Date().toLocaleDateString("en-CA");

  const [rowErrors, setRowErrors] = useState({});
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      returnDate: today,
    },
  });

  // const showMessage = (text, type = "error") => {
  //   setMessage(text);
  //   setMsgType(type);
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  //   messageTimer.current = setTimeout(() => setMessage(""), 4000);
  // };

  const formatQty3 = (val) => {
    if (val === null || val === undefined || val === "") return "0.000";
    return Number(val).toFixed(3);
  };

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
  };

  const clearMessage = () => {
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    setMessage("");
    setMsgType("");
  };


  // const loadProjects = async () => {
  //   const emp = StorageService.loginData();
  //   const comp = StorageService.activeCompany();

  //   try {
  //     let projectsData = [];

  //     // SUPER ADMIN → ALL PROJECTS BY COMPANY
  //     if (
  //       emp.roleName === "Super Admin" ||
  //       emp.roleName === "SuperAdmin" ||
  //       Number(emp.roleId) === 1
  //     ) {
  //       const res = await ProjectService.getActive(comp.companyId);

  //       projectsData = (res || []).map(p => ({
  //         projectId: p.id,
  //         projectName: p.projectName
  //       }));
  //     }
  //     //  NORMAL USER → ASSIGNED PROJECTS
  //     else {
  //       const res = await ProjectService.getAssignedProjects(
  //         comp.companyId,
  //         emp.employeeId
  //       );
  //       console.log("Projects dropdown data:", projects);
  //       projectsData = res?.data?.data || [];
  //     }

  //     setProjects(projectsData);
  //   } catch (err) {
  //     console.error("Error loading projects:", err);
  //     setProjects([]);
  //   }
  // };

  const loadProjects = async () => {
    const emp = StorageService.loginData();
    const comp = StorageService.activeCompany();

    try {
      let projectsData = [];

      // SUPER ADMIN & DATA ADMIN → ALL PROJECTS
      if (
        emp.roleName === "Super Admin" ||
        emp.roleName === "SuperAdmin" ||
        emp.roleName === "Data Admin" ||
        emp.roleName === "DataAdmin" ||
        Number(emp.roleId) === 1 ||
        Number(emp.roleId) === 2
      ) {
        const res = await ProjectService.getActive(comp.companyId);

        projectsData = (res || []).map(p => ({
          projectId: p.id,
          projectName: p.projectName,
          projectCode: p.projectCode   // ✅ ADD THIS
        }));
      }
      // NORMAL USER → ASSIGNED PROJECTS
      else {
        const res = await ProjectService.getAssignedProjects(
          comp.companyId,
          emp.employeeId
        );

        projectsData = (res?.data?.data || []).map(p => ({
          projectId: p.projectId,
          projectName: p.projectName,
          projectCode: p.projectCode   // ✅ ADD THIS
        }));
      }

      setProjects(projectsData);
    } catch (err) {
      console.error("Error loading projects:", err);
      setProjects([]);
    }
  };



  const loadStores = async (pId) => {
    try {
      const res = await ProjectStoreService.getProjectStoreById(pId);

      const list = res.data || res || [];
      const filtered = list.filter((s) => String(s.projectId) === String(pId));

      setStores(filtered);
    } catch (error) {
      console.error("Store load error:", error);
      setStores([]);
    }
  };

  const loadVouchers = async (projectId, storeId, projectLocationId, excludeId = null) => {
    if (!projectId || !storeId || !projectLocationId) return;

    try {
      const res = await stockReturnService.getVouchers(projectId, storeId, projectLocationId, excludeId);
      setVouchers(res.data || []);
    } catch (err) {
      console.error("Voucher load error", err);
      setVouchers([]);
    }
  };


  const loadTransporters = async () => {
    try {
      // dropdown should always load page 1
      const res = await TransporterService.getActiveTransporters(1, 100);

      const list = res?.data || [];
      setTransporters(list);
    } catch (err) {
      console.error("Transporter load error:", err);
      setTransporters([]);
    }
  };


  const loadProjectLocations = async (projectId, storeId) => {
    if (!projectId || !storeId) {
      setProjectLocations([]);
      setValue("projectLocationId", "");
      return;
    }

    try {
      const res = await ProjectLocationService.getByProjectAndStore(
        projectId,
        storeId
      );

      setProjectLocations(res?.data || []);
    } catch (err) {
      console.error("Location load error", err);
      setProjectLocations([]);
    }
  };


  const loadItems = async () => {
    try {
      const res = await ItemsService.getAllItems();
      setItems(res.data || res || []);
    } catch (error) {
      console.error("Items load error:", error);
      setItems([]);
    }
  };

  const fetchAvailableQuantity = async (projectId, storeId, itemId) => {
    const companyId = StorageService.activeCompany()?.companyId;

    if (!companyId || !projectId || !storeId || !itemId) return 0;

    try {
      const res = await StockIndentService.getAvailableStock(
        companyId,
        projectId,
        storeId,
        itemId
      );

      // SAME RESPONSE PATH AS INDENT
      return res?.data?.result?.quantity ?? 0;
    } catch (err) {
      console.error("Available qty fetch error", err);
      return 0;
    }
  };

  const fetchVoucherNo = async (projectId, storeId) => {
    if (!projectId || !storeId) return;

    try {
      const res = await stockReturnService.previewVoucherNo(projectId, storeId);
      setValue(
        "voucherNo",
        res?.data?.voucherNo || ""
      );
    } catch (err) {
      console.error("StockReturn voucher fetch error", err);
      setValue("voucherNo", "");
    }
  };


  //   useEffect(() => {
  //     const company = StorageService.activeCompany();
  //     if (company?.companyName) {
  //       setCompanyName(company.companyName);
  //     }

  //     loadProjects();
  //     loadTransporters(); 

  //    if (editId) {
  //   setIsEdit(true);

  //   (async () => {
  //     try {
  //       const res = await stockReturnService.getById(editId);

  //       const data = res?.data?.data || res?.data;

  //       if (!data) return;

  //       setValue("projectId", data.projectId);
  //       setValue("storeId", data.storeId);
  //       setValue("returnInvoiceNo", data.vocherNo);
  //       setValue("returnDate", data.returnDate?.slice(0, 10));
  //       setValue("stockReturnNotes", data.stockReturnNotes);

  //       setProjectId(data.projectId);

  //       // load dropdowns
  //       await loadStores(data.projectId);
  //       await loadVouchers(data.projectId, data.storeId);
  //       await loadProjectLocations(data.projectId, data.storeId);

  //       // load voucher items
  //       await loadItemsByVoucher(data.vocherNo);

  //       // set rows
  //       if (data.details?.length) {
  //         setReturnItems(
  //           data.details.map((d) => ({
  //             itemId: d.itemId,
  //             itemDescription: d.itemDescription,
  //             UOM: d.UOM,
  //             quantity: d.quantity,
  //             avalibleQty: 0
  //           }))
  //         );
  //       }

  //     } catch (err) {
  //       console.error(err);
  //       showMessage("Failed to load stock return details");
  //     }
  //   })();
  // }
  //   }, [editId, setValue]);


  useEffect(() => {
    const company = StorageService.activeCompany();
    if (company?.companyName) {
      setCompanyName(company.companyName);
    }

    loadProjects();
    loadTransporters();

    if (editId) {
      setIsEdit(true);

      (async () => {
        try {
          setLoadingEdit(true);

          const res = await stockReturnService.getById(editId);
          const data = res?.data?.data || res?.data;

          if (!data) return;

          setProjectId(String(data.projectId || ""));
          setValue("projectId", String(data.projectId || ""));

          // Wait for dropdown lists to load so that setting form values will select correct options
          await Promise.all([
            loadStores(Number(data.projectId)),
            loadProjectLocations(Number(data.projectId), Number(data.storeId)),
            loadVouchers(Number(data.projectId), Number(data.storeId), Number(data.locationId || 0), editId)
          ]);

          setValue("storeId", String(data.storeId || ""));
          setValue("projectLocationId", String(data.locationId || ""));
          setValue("transporterId", String(data.transporterId || ""));
          setValue("returnDate", data.returnDate?.slice(0, 10) || "");
          setValue("stockReturnNotes", data.stockReturnNotes || "");
          setValue("voucherNo", data.vocherNo || "");

          if (data.details?.length) {
            const rows = await Promise.all(
              data.details.map(async (d) => {
                const voucherNo = d.stockOutVoucherNo || "";
                let availableQty = 0;
                let issuedQty = 0;
                let availableUsable = 0;
                let availableDamaged = 0;
                let siteBalance = 0;
                if (voucherNo && d.itemId) {
                  const qtyRes = await stockReturnService.getAvailableQty(voucherNo, d.itemId, editId);
                  availableQty = qtyRes?.data?.availableQty || 0;
                  issuedQty = qtyRes?.data?.issuedQty || 0;
                  availableUsable = qtyRes?.data?.availableUsable || 0;
                  availableDamaged = qtyRes?.data?.availableDamaged || 0;
                  siteBalance = qtyRes?.data?.siteBalance || 0;
                }

                let vItems = [];
                if (voucherNo) {
                  const itemsRes = await stockReturnService.getItemsByVoucher(voucherNo, d.toStoreId || data.storeId, data.storeId, editId);
                  vItems = itemsRes?.data || [];
                }

                return {
                  stockOutVoucherNo: voucherNo,
                  itemId: d.itemId,
                  itemDescription: d.itemDescription || d.itemName || "",
                  UOM: d.UOM || "",
                  quantity: d.quantity ?? "",
                  issuedQty: Number(issuedQty),
                  avalibleQty: formatQty3(siteBalance),
                  voucherItems: vItems,
                  toStoreId: String(d.toStoreId || data.storeId || ""),
                  damagedQty: d.damagedQty ?? "",
                  availableUsable: Number(availableUsable),
                  availableDamaged: Number(availableDamaged),
                  tempUsable: d.quantity ?? "0.000",
                  tempDamaged: d.damagedQty ?? "0.000"
                };
              })
            );

            setReturnItems(rows);
          }
        } catch (err) {
          console.error(err);
          showMessage("Failed to load stock return details");
        } finally {
          setLoadingEdit(false);
        }
      })();
    }

  }, [editId]);

  useEffect(() => {
    if (!projectId) {
      setStores([]);
      setItems([]);
      return;
    }
    loadStores(projectId);
    loadItems();
    // loadTransporters();
  }, [projectId]);

  // Auto-select dropdowns if only 1 option is available
  useEffect(() => {
    if (projects.length === 1 && !isEdit) {
      const singleProj = projects[0];
      const pId = String(singleProj.projectId ?? singleProj.id);
      setValue("projectId", pId);
      setProjectId(pId);

      // Inline Project onChange logic:
      setStores([]);
      setProjectLocations([]);
      setValue("storeId", "");
      setValue("projectLocationId", "");
      setVouchers([]);
      setValue("returnInvoiceNo", "");
      setValue("voucherNo", "");
      loadStores(pId);
    }
  }, [projects, isEdit]);

  useEffect(() => {
    const headerStores = stores.filter((s) => {
      const code = (s.storeCode || "").trim().toLowerCase();
      return !code.startsWith("scrap");
    });
    if (headerStores.length === 1 && !isEdit) {
      const singleStore = headerStores[0];
      const sId = String(singleStore.storeId ?? singleStore.id);
      setValue("storeId", sId);

      // Inline Store onChange logic:
      setReturnItems(prev => prev.map(item => ({
        ...item,
        toStoreId: sId
      })));
      setProjectLocations([]);
      setValue("projectLocationId", "");
      setVouchers([]);
      setValue("returnInvoiceNo", "");
      setValue("voucherNo", "");
      if (projectId && sId) {
        loadProjectLocations(projectId, sId);
        fetchVoucherNo(projectId, sId);
      }
    }
  }, [stores, isEdit, projectId]);

  useEffect(() => {
    if (projectLocations.length === 1 && !isEdit) {
      const singleLoc = projectLocations[0];
      const lid = String(singleLoc.id);
      setValue("projectLocationId", lid);

      // Inline Location onChange logic:
      const pid = getValues("projectId");
      const sid = getValues("storeId");
      if (pid && sid && lid) {
        loadVouchers(pid, sid, lid, editId);
      } else {
        setVouchers([]);
        setValue("returnInvoiceNo", "");
      }
    }
  }, [projectLocations, isEdit]);

  useEffect(() => {
    if (transporters.length === 1 && !isEdit) {
      const singleTrans = transporters[0];
      const tId = String(singleTrans.id ?? singleTrans.transporterId);
      setValue("transporterId", tId);
    }
  }, [transporters, isEdit]);

  const handleAddRow = () => {
    const headerStore = getValues("storeId") || "";
    setReturnItems([...returnItems, { itemId: "", itemDescription: "", UOM: "", quantity: "", issuedQty: 0, avalibleQty: 0, stockOutVoucherNo: "", voucherItems: [], toStoreId: headerStore, damagedQty: "", availableUsable: 0, availableDamaged: 0, tempUsable: "0.000", tempDamaged: "0.000", loadingItems: false, loadingQty: false }]);
  };

  const hasDuplicateStockReturnItems = () => {
    const keys = returnItems
      .filter((r) => r.itemId && r.stockOutVoucherNo && r.toStoreId)
      .map((r) => `${String(r.stockOutVoucherNo).trim()}_${String(r.itemId).trim()}_${String(r.toStoreId).trim()}`);
    return keys.length !== new Set(keys).size;
  };

  const handleDeleteRow = (index) => {
    const updated = [...returnItems];
    updated.splice(index, 1);
    setReturnItems(updated);
  };

  // const handleChange = async (index, field, value) => {
  //   const updated = [...returnItems];
  //   const errorsCopy = { ...rowErrors };

  //   updated[index][field] = value;

  //   // VOUCHER CHANGE
  //   if (field === "vocherNo") {
  //     updated[index] = {
  //       itemId: "",
  //       itemDescription: "",
  //       UOM: "",
  //       quantity: "",
  //       avalibleQty: 0,
  //     };
  //     delete errorsCopy[index];
  //     await loadItemsByVoucher(value);
  //   }

  //   // ITEM CHANGE
  //   if (field === "itemId") {
  //     const selectedItem = voucherItems.find(
  //       (it) => String(it.itemId) === String(value)
  //     );

  //     if (selectedItem) {
  //       updated[index].UOM = selectedItem.UOM;
  //       updated[index].itemDescription = selectedItem.itemName;
  //     }

  //     const qtyRes = await stockReturnService.getAvailableQty(
  //       getValues("returnInvoiceNo"),
  //       value
  //     );

  //     updated[index].avalibleQty = qtyRes?.data?.availableQty ?? 0;
  //     updated[index].quantity = "";
  //     delete errorsCopy[index];
  //   }

  //   // LIVE QUANTITY VALIDATION
  //   if (field === "quantity") {
  //     const qty = Number(value);
  //     const avail = Number(updated[index].avalibleQty);

  //     if (!qty || qty <= 0) {
  //       const msg = "Return quantity must be greater than zero";
  //       errorsCopy[index] = msg;
  //       showMessage(msg, "error");
  //     } else if (qty > avail) {
  //       const msg = `Return quantity cannot exceed available quantity (${avail})`;
  //       errorsCopy[index] = msg;
  //       showMessage(msg, "error");
  //     } else {
  //       delete errorsCopy[index];

  //       // Clear top message ONLY if no other row errors exist
  //       if (Object.keys(errorsCopy).length === 0) {
  //         clearMessage();
  //       }
  //     }
  //   }

  //   setReturnItems(updated);
  //   setRowErrors(errorsCopy);
  // };


  const handleChange = async (index, field, value) => {
    const updated = [...returnItems];
    const errorsCopy = { ...rowErrors };

    updated[index][field] = value;

    // 🔹 VOUCHER CHANGE
    if (field === "vocherNo") {
      updated[index] = {
        ...updated[index],
        stockOutVoucherNo: value,
        itemId: "",
        itemDescription: "",
        UOM: "",
        quantity: "",
        issuedQty: 0,
        avalibleQty: 0,
        voucherItems: [],
        damagedQty: "",
        availableUsable: 0,
        availableDamaged: 0,
        loadingItems: !!value,
      };
      delete errorsCopy[index];
      setRowErrors(errorsCopy);
      setReturnItems(updated);

      if (value) {
        try {
          const res = await stockReturnService.getItemsByVoucher(value, updated[index].toStoreId, getValues("storeId"), editId);
          setReturnItems(prev => {
            const next = [...prev];
            if (next[index]) {
              next[index].voucherItems = res.data || [];
              next[index].loadingItems = false;
            }
            return next;
          });
        } catch (err) {
          console.error("Voucher items load error", err);
          setReturnItems(prev => {
            const next = [...prev];
            if (next[index]) next[index].loadingItems = false;
            return next;
          });
        }
      }
      return;
    }

    // 🔹 ITEM CHANGE
    if (field === "itemId") {
      if (
        value &&
        updated.some(
          (row, rowIndex) =>
            rowIndex !== index &&
            String(row.itemId) === String(value) &&
            String(row.stockOutVoucherNo) === String(updated[index].stockOutVoucherNo) &&
            String(row.toStoreId) === String(updated[index].toStoreId)
        )
      ) {
        showMessage("This item from the selected voucher with the same store is already added in another row.", "error");
        updated[index].itemId = "";
        setReturnItems(updated);
        return;
      }

      const selectedItem = (updated[index].voucherItems || []).find(
        (it) => String(it.itemId) === String(value)
      );

      updated[index].itemDescription = selectedItem?.itemName || selectedItem?.itemDescription || "";
      updated[index].UOM = selectedItem?.UOM || "";
      updated[index].issuedQty = Number(selectedItem?.issuedQty || 0);
      updated[index].avalibleQty = 0;
      updated[index].quantity = "0.000";
      updated[index].damagedQty = "0.000";

      if (value && updated[index].stockOutVoucherNo) {
        updated[index].loadingQty = true;
        setReturnItems(updated);

        try {
          const qtyRes = await stockReturnService.getAvailableQty(
            updated[index].stockOutVoucherNo,
            value,
            editId
          );

          const resData = qtyRes?.data || {};
          setReturnItems(prev => {
            const next = [...prev];
            if (next[index]) {
              next[index].issuedQty = Number(resData.issuedQty || selectedItem?.issuedQty || 0);
              next[index].avalibleQty = formatQty3(resData.siteBalance || 0);
              next[index].availableUsable = Number(resData.availableUsable || 0);
              next[index].availableDamaged = Number(resData.availableDamaged || 0);

              next[index].tempUsable = formatQty3(resData.availableUsable || 0);
              next[index].tempDamaged = formatQty3(resData.availableDamaged || 0);

              if (!checkIsScrapStore(next[index].toStoreId)) {
                next[index].quantity = formatQty3(resData.availableUsable || 0);
                next[index].damagedQty = "0.000";
              } else {
                next[index].quantity = "0.000";
                next[index].damagedQty = formatQty3(resData.availableDamaged || 0);
              }
              next[index].loadingQty = false;
            }
            return next;
          });
        } catch (err) {
          console.error("Error fetching available qty on item change", err);
          setReturnItems(prev => {
            const next = [...prev];
            if (next[index]) next[index].loadingQty = false;
            return next;
          });
        }
      } else {
        setReturnItems(updated);
      }
      delete errorsCopy[index];
      delete errorsCopy[`dmg_${index}`];
    }

    // 🔹 LIVE QUANTITY VALIDATION
    if (field === "quantity") {
      const qty = Number(value);
      const maxUsable = Number(updated[index].availableUsable || 0);

      if (!qty || qty <= 0) {
        const msg = "Return quantity must be greater than zero";
        errorsCopy[index] = msg;
        showMessage(msg, "error");
      } else if (qty > maxUsable) {
        const msg = `Return quantity cannot exceed available returnable quantity (${maxUsable})`;
        errorsCopy[index] = msg;
        showMessage(msg, "error");
      } else {
        delete errorsCopy[index];
        if (Object.keys(errorsCopy).length === 0) {
          clearMessage();
        }
      }
    }

    setReturnItems(updated);
    setRowErrors(errorsCopy);
  };



  const handleQuantityChange = (index, e) => {
    let value = e.target.value;

    // allow only numbers + decimal with at most 3 decimal places
    if (value !== "" && !/^\d*\.?\d{0,3}$/.test(value)) return;

    const updated = [...returnItems];
    const errorsCopy = { ...rowErrors };

    updated[index] = {
      ...updated[index],
      quantity: value,
      tempUsable: value
    };

    const qty = Number(value);
    const maxUsable = Number(updated[index].availableUsable || 0);

    if (value !== "" && (!Number.isFinite(qty) || qty <= 0)) {
      errorsCopy[index] = "Return quantity must be greater than zero";
      showMessage("Return quantity must be greater than zero", "error");
    } else if (value !== "" && qty > maxUsable) {
      errorsCopy[index] = `Return quantity cannot exceed available returnable quantity (${maxUsable.toFixed(3)})`;
      showMessage(`Return quantity cannot exceed available returnable quantity (${maxUsable.toFixed(3)})`, "error");
    } else {
      delete errorsCopy[index];
      if (Object.keys(errorsCopy).length === 0) {
        clearMessage();
      }
    }

    setReturnItems(updated);
    setRowErrors(errorsCopy);
  };

  const handleQuantityBlur = (index) => {
    setReturnItems(prev => {
      const updated = [...prev];
      const val = updated[index].quantity;
      if (val !== "" && !isNaN(Number(val))) {
        const formatted = Number(val).toFixed(3);
        updated[index].quantity = formatted;
        updated[index].tempUsable = formatted;
      }
      return updated;
    });
  };

  const handleDamagedQtyChange = (index, e) => {
    let value = e.target.value;

    if (value !== "" && !/^\d*\.?\d{0,3}$/.test(value)) return;

    const updated = [...returnItems];
    const errorsCopy = { ...rowErrors };

    updated[index] = {
      ...updated[index],
      damagedQty: value,
      tempDamaged: value
    };

    const dmg = Number(value);
    const maxDamaged = Number(updated[index].availableDamaged || 0);

    if (value !== "" && (!Number.isFinite(dmg) || dmg < 0)) {
      errorsCopy[`dmg_${index}`] = "Damaged quantity must be a non-negative number";
      showMessage("Damaged quantity must be a non-negative number", "error");
    } else if (value !== "" && dmg > maxDamaged) {
      errorsCopy[`dmg_${index}`] = `Damaged quantity cannot exceed available damaged quantity (${maxDamaged.toFixed(3)})`;
      showMessage(`Damaged quantity cannot exceed available damaged quantity (${maxDamaged.toFixed(3)})`, "error");
    } else {
      delete errorsCopy[`dmg_${index}`];
      if (Object.keys(errorsCopy).filter(k => k.startsWith("dmg_")).length === 0) {
        clearMessage();
      }
    }

    setReturnItems(updated);
    setRowErrors(errorsCopy);
  };

  const handleDamagedQtyBlur = (index) => {
    setReturnItems(prev => {
      const updated = [...prev];
      const val = updated[index].damagedQty;
      if (val !== "" && !isNaN(Number(val))) {
        const formatted = Number(val).toFixed(3);
        updated[index].damagedQty = formatted;
        updated[index].tempDamaged = formatted;
      }
      return updated;
    });
  };


  const loadItemsByVoucher = async (voucherNo) => {
    if (!voucherNo) return [];

    try {
      const res = await stockReturnService.getItemsByVoucher(voucherNo);
      return res.data || [];
    } catch (err) {
      console.error("Voucher items load error", err);
      return [];
    }
  };



  const onSubmit = async (data) => {
    try {
      setLoading(true);

      const emp = StorageService.loginData();
      const comp = StorageService.activeCompany();

      if (!data.transporterId) {
        showMessage("Transporter is required.", "error");
        setLoading(false);
        return;
      }

      if (hasDuplicateStockReturnItems()) {
        showMessage("Duplicate items are not allowed in Stock Return details.", "error");
        setLoading(false);
        return;
      }

      const now = new Date().toISOString();


      // MAIN PAYLOAD (MATCH BACKEND)
      const stockReturnPayload = {
        companyId: comp.companyId,
        projectId: data.projectId,
        storeId: data.storeId,
        locationId: data.projectLocationId || null,
        vocherNo: data.voucherNo,
        transporterId: data.transporterId || null,
        stockReturnNotes: data.stockReturnNotes,
        returnType: "NORMAL",
        returnDate: data.returnDate,
        status: "pending",
        createdBy: emp.employeeId,
        createdDate: now,
        updatedBy: emp.employeeId,
        updatedDate: now,

        // DETAILS
        stockReturnDetails: returnItems.map((item) => {
          const isScrap = checkIsScrapStore(item.toStoreId);
          return {
            itemId: item.itemId,
            UOM: item.UOM,
            quantity: !isScrap ? (item.quantity || "0.000") : "0.000",
            stockOutVoucherNo: item.stockOutVoucherNo,
            toStoreId: item.toStoreId,
            damagedQty: isScrap ? (item.damagedQty || "0.000") : "0.000",
            status: "Active",
            createdBy: emp.employeeId,
            createdDate: now,
          };
        }),
      };

      let res;

      if (isEdit && editId) {
        res = await stockReturnService.update(editId, stockReturnPayload);
      } else {
        res = await stockReturnService.save(stockReturnPayload);
      }

      if (res?.status === "true" || res?.status === true) {
        showMessage(
          isEdit ? "Stock Return updated successfully!" : "Stock Return saved successfully!",
          "success"
        );
        setTimeout(() => navigate("/cpnl/stockReturn/view"), 1000);
      } else {
        showMessage(res?.message || "Failed to save Stock Return.", "error");
      }
    } catch (error) {
      console.error("Stock Return Save Error:", error);

      const msg =
        error?.response?.data?.message ||
        "An error occurred while saving Stock Return.";

      showMessage(msg, "error");
    } finally {
      setLoading(false);
    }
  };


  const handleCancel = () => {
    setTimeout(() => navigate("/cpnl/stockReturn/view"), 800);
  };

  if (loadingEdit) {
    return <Loading />;
  }

  return (
    <>
      <Breadcrumb
        pageTitle={isEdit ? "Modify Stock Return" : "Add Stock Return"}
        secondTitle="Inventory"
      ></Breadcrumb>

      <div className="card p-4 bg-white shadow-sm">

        {/* ADD THIS HERE
        {message && (
          <div
            className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
              }`}
            role="alert"
          >
            {message}
          </div>
        )} */}
        <MessageDialog
          message={message}
          type={msgType}
          setMessage={setMessage}
          setMsgType={setMsgType}
        />

        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <div className="row">
            <div className="mb-3 col-md-4">
              <label className="form-label">
                Project <span className="text-danger">*</span>
              </label>

              <select
                className="form-select"
                {...register("projectId", { required: "Project ID is required" })}
                onChange={(e) => {
                  const pid = e.target.value;
                  setProjectId(pid);
                  setValue("projectId", pid);

                  // CLEAR OLD DATA
                  setStores([]);
                  setProjectLocations([]);
                  setValue("storeId", "");
                  setValue("projectLocationId", "");
                  setVouchers([]);
                  setValue("returnInvoiceNo", "");
                  setValue("voucherNo", "");

                  loadStores(pid);
                }}
              >

                <option value="">Select Project</option>
                {projects.map((p) => (
                  <option key={p.projectId} value={p.projectId}>
                    {p.projectCategoryName ? `${String(p.projectCategoryName).trim().charAt(0).toUpperCase()}*${p.projectName}` : (p.projectCode ? `${String(p.projectCode).trim().charAt(0).toUpperCase()}*${p.projectName}` : p.projectName)}
                  </option>
                ))}
              </select>

              {errors.projectId && (
                <small className="text-danger">{errors.projectId.message}</small>
              )}
            </div>

            <div className="mb-3 col-md-4">
              <label className="form-label">
                To Store <span className="text-danger">*</span>
              </label>

              <select
                className="form-select"
                {...register("storeId", { required: "To Store is required" })}
                onChange={(e) => {
                  const sid = e.target.value;
                  setValue("storeId", sid);

                  // Reset returnItems to single empty row and clear errors
                  setReturnItems([
                    { itemId: "", itemDescription: "", UOM: "", quantity: "", issuedQty: 0, avalibleQty: 0, stockOutVoucherNo: "", voucherItems: [], toStoreId: sid, damagedQty: "", availableUsable: 0, availableDamaged: 0, tempUsable: "0.000", tempDamaged: "0.000", loadingItems: false, loadingQty: false }
                  ]);
                  setRowErrors({});
                  clearMessage();

                  // CLEAR OLD LOCATION & VOUCHERS
                  setProjectLocations([]);
                  setValue("projectLocationId", "");
                  setVouchers([]);
                  setValue("returnInvoiceNo", "");
                  setValue("voucherNo", "");

                  if (projectId && sid) {
                    loadProjectLocations(projectId, sid);
                    fetchVoucherNo(projectId, sid);
                  }
                }}
              >

                <option value="">Select To Store</option>
                {stores
                  .filter((s) => {
                    const code = (s.storeCode || "").trim().toLowerCase();
                    return !code.startsWith("scrap");
                  })
                  .map((s) => (
                    <option key={s.storeId} value={s.storeId}>
                      {s.storeName}
                    </option>
                  ))}
              </select>

              {errors.storeId && (
                <small className="text-danger">{errors.storeId.message}</small>
              )}
            </div>

            <div className="mb-3 col-md-4">
              <label className="form-label">
                From Location <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                {...register("projectLocationId", {
                  required: "From Location is required",
                  onChange: (e) => {
                    const lid = e.target.value;
                    const pid = getValues("projectId");
                    const sid = getValues("storeId");
                    if (pid && sid && lid) {
                      loadVouchers(pid, sid, lid, editId);
                    } else {
                      setVouchers([]);
                      setValue("returnInvoiceNo", "");
                    }
                  }
                })}
                disabled={!getValues("storeId")}
              >
                <option value="">Select From Location</option>
                {projectLocations.map((l) => (
                  <option key={l.id} value={l.id}>
                    {l.locationName}
                  </option>
                ))}
              </select>
              {errors.projectLocationId && (
                <small className="text-danger">{errors.projectLocationId.message}</small>
              )}
            </div>
          </div>

          <div className="row">
            {/* Voucher No */}
            <div className="mb-3 col-md-4">
              <label className="form-label">Voucher No</label>
              <input
                type="text"
                className="form-control"
                {...register("voucherNo")}
                readOnly
              />
            </div>

            {/* TRANSPORTER */}
            <div className="mb-3 col-md-4">
              <label className="form-label">
                Transporter <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                {...register("transporterId", {
                  required: "Transporter is required",
                })}
              >
                <option value="">Select Transporter</option>
                {transporters.map((t) => (
                  <option
                    key={t.id ?? t.transporterId}
                    value={t.id ?? t.transporterId}
                  >
                    {t.transporterName || t.name}
                  </option>
                ))}
              </select>
              {errors.transporterId && (
                <small className="text-danger">
                  {errors.transporterId.message}
                </small>
              )}
            </div>

            <div className="mb-3 col-md-4">
              <label className="form-label">
                Return Date <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                {...register("returnDate", {
                  required: "Return Date is required",
                  validate: (value) => {
                    if (!value) return true;

                    const selectedDate = value; // yyyy-mm-dd
                    const today = new Date().toLocaleDateString("en-CA"); // yyyy-mm-dd

                    return (
                      selectedDate <= today ||
                      "Future dates are not allowed"
                    );
                  },
                })}
              />
              {errors.returnDate && (
                <small className="text-danger">{errors.returnDate.message}</small>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-md-4 mb-3">
              <label className="form-label">Notes</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter notes"
                {...register("stockReturnNotes")}
              />
            </div>
          </div>

          <hr />
          <h5>Stock Return Details</h5>

          <div className="table-responsive mt-2" style={{
            maxHeight: returnItems.length >= 4 ? "320px" : "auto",
            overflowY: returnItems.length >= 4 ? "auto" : "visible",
            overflowX: "auto"
          }}>
            <table className="table table-bordered mb-0">
              <thead className="table-light sticky-top" style={{ zIndex: 2 }}>
                <tr>
                  <th style={{ minWidth: "250px" }}>Stock Out InvoiceNo</th>
                  <th style={{ minWidth: "180px" }}>To Store</th>
                  <th style={{ minWidth: "370px" }}>Item</th>
                  <th style={{ minWidth: "280px" }}>item Description</th>
                  <th style={{ minWidth: "90px" }}>UOM</th>
                  <th colSpan={4} className="text-center">Quantity</th>
                  <th style={{ minWidth: "100px" }}>Action</th>
                </tr>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th style={{ minWidth: "110px" }}>Issued</th>
                  <th style={{ minWidth: "110px" }}>Site Balance</th>
                  <th style={{ minWidth: "110px" }}>Return</th>
                  <th style={{ minWidth: "110px" }}>Damaged</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {returnItems.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <select
                        className="form-select"
                        value={row.stockOutVoucherNo || ""}
                        onChange={(e) => {
                          handleChange(index, "vocherNo", e.target.value);
                        }}
                        disabled={!getValues("projectId") || !getValues("storeId") || !getValues("projectLocationId")}
                      >
                        <option value="">Select Voucher No</option>
                        {vouchers.map((v, i) => (
                          <option key={i} value={v.vocherNo}>
                            {v.vocherNo}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <select
                        className="form-select"
                        value={row.toStoreId || ""}
                        onChange={(e) => {
                          const newStoreId = e.target.value;
                          if (
                            newStoreId &&
                            returnItems.some(
                              (row, rowIndex) =>
                                rowIndex !== index &&
                                String(row.itemId) === String(returnItems[index].itemId) &&
                                String(row.stockOutVoucherNo) === String(returnItems[index].stockOutVoucherNo) &&
                                String(row.toStoreId) === String(newStoreId)
                            )
                          ) {
                            showMessage("This item from the selected voucher with the same store is already added in another row.", "error");
                            return;
                          }

                          const updated = [...returnItems];
                          updated[index].toStoreId = newStoreId;

                          const headerStoreId = getValues("storeId");
                          const errorsCopy = { ...rowErrors };
                          const isScrap = checkIsScrapStore(newStoreId);

                          if (!isScrap) {
                            // If it is a normal store, we are returning normal items, reset damaged quantity
                            updated[index].damagedQty = "0.000";
                            delete errorsCopy[`dmg_${index}`];

                            // Restore original available usable quantity if item is selected
                            if (updated[index].itemId) {
                              updated[index].quantity = formatQty3(updated[index].availableUsable || 0);
                            }
                          } else {
                            // If it is a scrap store, we are returning damaged items, reset return quantity
                            updated[index].quantity = "0.000";
                            delete errorsCopy[index];

                            // Restore original available damaged quantity if item is selected
                            if (updated[index].itemId) {
                              updated[index].damagedQty = formatQty3(updated[index].availableDamaged || 0);
                            }
                          }

                          if (Object.keys(errorsCopy).length === 0) {
                            clearMessage();
                          }
                          setRowErrors(errorsCopy);

                          if (updated[index].stockOutVoucherNo) {
                            updated[index].loadingItems = true;
                            setReturnItems(updated);
                            (async () => {
                              try {
                                const res = await stockReturnService.getItemsByVoucher(
                                  updated[index].stockOutVoucherNo,
                                  newStoreId,
                                  headerStoreId,
                                  editId
                                );
                                setReturnItems(prev => {
                                  const next = [...prev];
                                  if (next[index]) {
                                    next[index].voucherItems = res.data || [];
                                    next[index].loadingItems = false;

                                    const stillExists = (res.data || []).some(
                                      (it) => String(it.itemId) === String(next[index].itemId)
                                    );
                                    if (!stillExists) {
                                      next[index].itemId = "";
                                      next[index].itemDescription = "";
                                      next[index].UOM = "";
                                      next[index].issuedQty = 0;
                                      next[index].avalibleQty = 0;
                                      next[index].quantity = "0.000";
                                      next[index].damagedQty = "0.000";
                                      next[index].availableUsable = 0;
                                      next[index].availableDamaged = 0;
                                      next[index].tempUsable = "0.000";
                                      next[index].tempDamaged = "0.000";
                                    }
                                  }
                                  return next;
                                });
                              } catch (err) {
                                console.error("Error reloading voucher items on store change", err);
                                setReturnItems(prev => {
                                  const next = [...prev];
                                  if (next[index]) next[index].loadingItems = false;
                                  return next;
                                });
                              }
                            })();
                          } else {
                            setReturnItems(updated);
                          }
                        }}
                      >
                        <option value="">Select Store</option>
                        {stores.map((s) => (
                          <option key={s.storeId} value={s.storeId}>
                            {s.storeName}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <Select
                        isLoading={row.loadingItems}
                        value={
                          (row.voucherItems || [])
                            .map((it) => ({
                              value: it.itemId,
                              label: it.itemCode,
                            }))
                            .find((opt) => String(opt.value) === String(row.itemId)) || null
                        }
                        onChange={(selected) =>
                          handleChange(index, "itemId", selected ? selected.value : "")
                        }
                        options={(row.voucherItems || []).map((it) => ({
                          value: it.itemId,
                          label: it.itemCode,
                        }))}
                        placeholder="Search Item..."
                        isClearable
                        menuPlacement="auto"
                        maxMenuHeight={150}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        components={{ DropdownIndicator: null, IndicatorSeparator: null }}
                      />
                    </td>

                    <td>
                      <input className="form-control fw-bold text-dark"
                        value={row.itemDescription || ""}
                        readOnly />
                    </td>

                    <td>
                      <input
                        type="text"
                        className="form-control fw-bold text-dark"
                        value={row.UOM}
                        readOnly
                      />
                    </td>

                    <td>
                      <input type="text"
                        className="form-control fw-bold text-dark text-end"
                        value={row.loadingQty ? "Loading..." : Number(row.issuedQty || 0).toFixed(3)}
                        readOnly
                      />
                    </td>

                    <td>
                      <input type="text"
                        className="form-control fw-bold text-dark text-end"
                        value={row.loadingQty ? "Loading..." : Number(row.avalibleQty || 0).toFixed(3)}
                        readOnly
                      />
                    </td>

                    <td>
                      {!checkIsScrapStore(row.toStoreId) ? (
                        <input
                          type="text"
                          className="form-control fw-bold text-dark text-end"
                          value={row.loadingQty ? "Loading..." : (row.quantity ?? "")}
                          onChange={(e) => handleQuantityChange(index, e)}
                          onBlur={() => handleQuantityBlur(index)}
                          placeholder="Quantity"
                          disabled={row.loadingQty}
                        />
                      ) : (
                        <div className="text-center text-muted fw-bold py-1">-</div>
                      )}
                    </td>

                    <td>
                      {checkIsScrapStore(row.toStoreId) ? (
                        <input
                          type="text"
                          className="form-control fw-bold text-dark text-end"
                          value={row.loadingQty ? "Loading..." : (row.damagedQty ?? "")}
                          onChange={(e) => handleDamagedQtyChange(index, e)}
                          onBlur={() => handleDamagedQtyBlur(index)}
                          placeholder="Damaged Qty"
                          disabled={row.loadingQty}
                        />
                      ) : (
                        <div className="text-center text-muted fw-bold py-1">-</div>
                      )}
                    </td>

                    <td className="text-center">
                      <button
                        type="button"
                        className="btn btn-success btn-sm me-2"
                        onClick={handleAddRow}
                      >
                        +
                      </button>

                      {returnItems.length > 1 && (
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDeleteRow(index)}
                        >
                          -
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-3">
            <button
              type="submit"
              className="btn btn-primary me-2"
              disabled={loading}
            >
              <i className="ti ti-circle-check me-1"></i>
              {loading ? (isEdit ? "Updating..." : "Saving...") : isEdit ? "Update" : "Save"}
            </button>

            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleCancel}
              disabled={loading}
            >
              <i className="ti ti-cancel me-1"></i>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
